import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';

export class VariantDetailController {

  public static $inject = ['$state', '$stateParams', 'ACTToolbarService'];
  public variantSchemaFields: any;
  public variantBaseFields: any;

  constructor(
        private $state: ng.ui.IStateService,
        private $stateParams,
        private ActToolbarService: ACTToolbarService) {
    this.variantBaseFields = {
      name: $stateParams.variant.name,
      description: $stateParams.variant.description,
      retailReference: $stateParams.variant.retailReference,
      type: $stateParams.variant.type,
      stockItem: $stateParams.variant.stockItem
    };
    this.variantSchemaFields = $stateParams.variant.fields;
    this.activate();
  }

  public exitCreateVariant = () => {
    this.$state.go('variants.list', {
      catalogueId: this.$stateParams.catalogueId,
      productId: this.$stateParams.productId
        });
      }

      private activate() {
        this.ActToolbarService.getToolbar('primary').then((toolbar) => {
          toolbar.setTitle('Variant Details');
    });
  }
}